import React from "react";
import { nanoid } from "nanoid";
import Modal from "./UI/Modal";

const MainCards = (props) => {
  const { excelData } = props;

  const mainCards =
    excelData.length !== 0 &&
    excelData.map((node) => {
      const id = nanoid();
      return (
        <Modal
          className="tw-rounded-md tw-h-full tw-relative tw-cursor-pointer tw-flex tw-flex-col tw-text-white tw-shadow-lg"
          key={id}
          header={node.generatedDegreeName}
          originalImage={node.imageUrl}
          image={node.imageUrlImage}
          degree={node.generatedDegreeName}
          delivery={
            Array.isArray(node.delivery)
              ? node.delivery.join(", ")
              : node.delivery
          }
        >
          <p>{node.description}</p>
          {node.licensure && (
            <p className="tw-text-left tw-self-start tw-justify-self-start tw-mt-4">
              <strong>Licensure: </strong>
              {node.licensure.join(", ")}
            </p>
          )}
          <a
            href={node.pageUrl}
            target="_blank"
            aria-labelledby={id}
            rel="nofollow noreferrer"
            className="tw-bg-green-500 tw-text-white hover:tw-bg-green-600 tw-px-4 tw-py-2 tw-rounded-full tw-mt-8 tw-font-bold tw-transition tw-ease-in tw-duration-300"
            style={{ color: "white", textDecoration: "none" }}
          >
            Learn More
          </a>
          <p id={id} className="tw-sr-only">
            Learn More (opens in new window)
          </p>
        </Modal>
      );
    });

  return (
    <div className="cards tw-grid md:tw-grid-cols-3 sm:tw-grid-cols-2 tw-grid-cols-1 lg:tw-grid-cols-4 tw-gap-4">
      {mainCards}
    </div>
  );
};

export default MainCards;
